
const Contact = () => {

    return (
        <div>
            <div className="section-content-container">
            <h1 className="titles">Contact</h1>
            <p className="subtitle"> If you have any questions or would like to reschedule your Alpha DogWalk session, please email us at:
            </p>
            <hr className="section-divider" />

            <p className='text-content-contact'>
                <a className="email" href="mailto:info@alphadogwalks.com">info@alphadogwalks.com</a>
            </p>
        </div>
        </div>
        
    )


}

export default Contact;